import React from "react";

import { UniversesLayout } from "@companion-core/shared/app/Components/Blocks/Layouts/UniversesLayout";
import { BlockProps } from "@companion-core/shared/app/Interfaces/blocks";
import { APIUniverse } from "@companion-core/shared/app/Interfaces/API";

export const Universe = ({ queryBlockItems, stepperGoToNext }: BlockProps) => {
  const universes = queryBlockItems[0]?.components.data as APIUniverse[];
  return <UniversesLayout universes={universes} skipAction={() => stepperGoToNext?.({})} />;
};
